import { httpV2 } from "@/api/index";

/**
* @summary Busca o log de modificações de diagnóstico.
* @param {number} monitoringElementId - Id do ativo monitorado.
* @param {object} dateTimeParams - Objeto contendo o intervalo de tempo selecionado.
* @returns {object} JSON com as modificações nos controladores baseado no intervalo de tempo.
*/

const GetFilteredAuditLogData = function(monitoringElementId, dateTimeParams)
{
	return httpV2.get(`/AuditLoggingsDiagnostic
		?assetMonitoringElementId=${monitoringElementId}
		&startDateTime=${dateTimeParams.startDateTime}
		&endDateTime=${dateTimeParams.endDateTime}`);
};

export default
{ GetFilteredAuditLogData };